import React from 'react';

import { useResponsive } from '@garnish/core';

import { ConfirmLocationLayoutSM } from './ConfirmLocationLayoutSM';
import { ConfirmLocationLayoutXS } from './ConfirmLocationLayoutXS';

import type { ConfirmLocationLayoutProps } from './ConfirmLocationLayout.types';

export const ConfirmLocationLayout = (props: ConfirmLocationLayoutProps) => {
  const { match } = useResponsive();
  const ConfirmLocationLayoutComponent = match([ConfirmLocationLayoutXS, ConfirmLocationLayoutSM]);

  return <ConfirmLocationLayoutComponent {...props} />;
};
